'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { Textarea } from '@pickleballinc/ui/components/ui/textarea';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';

import { ActionButtons } from '@/components/molecules';
import { EditRegistrationData, editRegistrationSchema } from '@/entities/EditOrganizationModalSchemeData';

interface WithdrawPlayerFormProps {
	onSubmit: (data: EditRegistrationData) => void;
	onClose: () => void;
}

export const WithdrawPlayerForm = ({ onSubmit, onClose }: WithdrawPlayerFormProps) => {
	const form = useForm<EditRegistrationData>({
		resolver: zodResolver(editRegistrationSchema),
		defaultValues: {
			comment: ''
		}
	});

	const { formState, register, handleSubmit } = form;

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<p className="pb-1 pt-4 text-xs text-gray-500">Comments:</p>
			<Textarea
				{...register('comment')}
				className={clsx('pt-4 focus-visible:ring-0', {
					'border-error-600 focus-visible:ring-1 focus-visible:ring-error-600': !!formState.errors.comment
				})}
				placeholder="Enter your comment"
			/>
			{!!formState.errors.comment && <p className="text-sm text-error-600">{formState.errors.comment?.message?.toString()}</p>}

			<ActionButtons
				className="flex place-self-end !px-[10px] !py-[16px]"
				closeButtonClassName="w-full"
				submitButtonClassName="w-full"
				onClose={onClose}
				submitButtonText="Send"
				closeButtonText="Cancel"
				submitButtonDisabled={formState.isSubmitting || !formState.isDirty}
			/>
		</form>
	);
};
